export function toCamelCase (str) {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace('-', '').replace('_', '')
  )
}

export function isObject (obj) {
  return obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function'
}

export function keysToCamelCase (obj) {
  if (isObject(obj)) {
    const newObject = {}

    Object.keys(obj)
      .forEach((key) => {
        newObject[toCamelCase(key)] = keysToCamelCase(obj[key])
      })

    return newObject
  } else if (Array.isArray(obj)) {
    return obj.map((item) => {
      return keysToCamelCase(item)
    })
  }

  return obj
}

export default function dataPropsParser (props) {
  const parsedProps = JSON.parse(props)
  return keysToCamelCase(parsedProps)
}
